export default {
  path: 'meta-data',
  name: 'vendor/meta-data',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-metadata" */ './MetaData')
}
